import { render, staticRenderFns } from "./DriverFaceFile.vue?vue&type=template&id=c5d81c64&scoped=true&"
import script from "./DriverFaceFile.vue?vue&type=script&lang=js&"
export * from "./DriverFaceFile.vue?vue&type=script&lang=js&"
import style0 from "./DriverFaceFile.vue?vue&type=style&index=0&id=c5d81c64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d81c64",
  null
  
)

export default component.exports